import { FluentBundle, FluentResource } from "@fluent/bundle";
import { createFluentVue } from "fluent-vue";

// en-US is embedded as a fallback
import enMessages from "@locales/en-US.ftl?raw";
import { lang, locale } from "@/config";

const bundles: FluentBundle[] = [];

if (lang && locale) {
    const bundle = new FluentBundle([lang]);
    bundle.addResource(new FluentResource(locale));
    bundles.push(bundle);
}

const bundle = new FluentBundle(["en-US", "en"]);
bundle.addResource(new FluentResource(enMessages));
bundles.push(bundle);

export const fluent = createFluentVue({
    bundles,
});

export const $tr = fluent.format;
